import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	errorFlagTitle: {
		id: 'browser-status-indicator.conflict-resolution-plugin.copy-page.error-flag.title',
		defaultMessage: 'We failed to create a copy',
		description: 'Title for the error flag if copying conflicted page fails',
	},
	errorFlagDescription: {
		id: 'browser-status-indicator.conflict-resolution-plugin.copy-page.error-flag.description',
		defaultMessage: 'Check your network connection or try again.',
		description: 'Description for the error flag if copying conflicted page fails',
	},
	copyCreatedFlagTitle: {
		id: 'browser-status-indicator.conflict-resolution-plugin.copy-page.copy-created-flag.title',
		defaultMessage: 'Copy created',
		description: 'Title for the flag if copying conflicted page is successful',
	},
	copyCreatedFlagDescription: {
		id: 'browser-status-indicator.conflict-resolution-plugin.copy-page.copy-created-flag.description',
		defaultMessage: 'We copied your offline edits into a new page. All changes were saved.',
		description: 'Description for the flag if copying conflicted page is successful',
	},
	copyCreatedFlagViewPage: {
		id: 'browser-status-indicator.conflict-resolution-plugin.copy-page.copy-created-flag.view-page-link',
		defaultMessage: 'View page',
		description: 'Description for the flag if copying conflicted page is successful',
	},
	createCopyFlagTitle: {
		id: 'browser-status-indicator.conflict-resolution-plugin.copy-page.create-copy-flag.title',
		defaultMessage: 'Issue syncing offline edits',
		description:
			'Title for the flag to warn and allow copy if a conflicted page is detected on reconnection',
	},
	createCopyFlagDescription: {
		id: 'browser-status-indicator.conflict-resolution-plugin.copy-page.create-copy-flag.description',
		defaultMessage:
			'We found conflicting edits when syncing to the cloud. View merged edits here or create a copy of your offline changes.',
		description:
			'Description for the flag to warn and allow copy if a conflicted page is detected on reconnection',
	},
	createCopyFlagCreateAction: {
		id: 'browser-status-indicator.conflict-resolution-plugin.copy-page.create-copy-flag.create-action',
		defaultMessage: 'Create copy',
		description:
			'Action in a flag to create a copy of the page if a conflicted page is detected on reconnection',
	},
	createCopyFlagNoAction: {
		id: 'browser-status-indicator.conflict-resolution-plugin.copy-page.create-copy-flag.no-action',
		defaultMessage: 'I don’t need a copy',
		description:
			'Action in a flag to dismiss the flag to create a copy if a conflicted page is detected on reconnection',
	},
});
